import { MagnifyingGlass, X } from '@phosphor-icons/react';
import { RootState, useAppSelector } from '../../store';
import useSearchFilter from '../../Hooks/useSearchFilter';
import { PaginationListType } from '../../Types/PaginationParams';

interface PaginationSearchFilterProps {
    children?: (filterNode: React.ReactNode, queryString: string | null) => React.ReactNode;
    className?: string;
    listType?: PaginationListType;
}

function PaginationSearchFilter({ className = '', children, listType }: PaginationSearchFilterProps) {
    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
        listType: listType,
    });

    const hasValue = (localQuery ?? '').trim().length > 0;
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            console.log(query);
            searchActions.applyQuery();
        }
    };

    const handleClear = () => {
        searchActions.setLocalQuery('');
        if (searchActions.clearQuery) {
            searchActions.clearQuery();
        }
    };

    const filterNode = (
        <>
            <div className={`flex flex-col relative max-w-[300px] ${className}`}>
                <input
                    className={`text-layout-textcolor bg-input-backgroundColor w-full p-3 border border-2 border-input-borderColor rounded-lg outline-none focus:border-primary transition-all duration-100 ${
                        hasValue ? 'pr-16' : 'pr-10'
                    }`}
                    type="text"
                    value={localQuery ?? ''}
                    onChange={(e) => searchActions.setLocalQuery(e.target.value)}
                    placeholder={i18n.translate({ id: 'filter.placeholder', sourceName: 'Main' })}
                    onKeyDown={handleKeyDown}
                />

                <span className="absolute right-3 h-full flex items-center gap-2">
                    {hasValue ? (
                        <div
                            className="w-4 h-4 cursor-pointer text-layout-textcolor hover:text-primary transition-colors"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleClear();
                            }}
                        >
                            <X />
                        </div>
                    ) : (
                        <></>
                    )}

                    <div
                        className="w-4 h-4 cursor-pointer text-layout-textcolor hover:text-primary transition-colors"
                        onClick={(e) => {
                            e.stopPropagation();
                            searchActions.applyQuery();
                        }}
                    >
                        <MagnifyingGlass />
                    </div>
                </span>
            </div>
        </>
    );

    if (children) {
        return <>{children(filterNode, query)}</>;
    }

    return filterNode;
}

export default PaginationSearchFilter;
